import { Layout } from "antd";
import PageContent from "../../routes";

const DesktopLayout = () => {
  return (
    <Layout id="app" className="desktop-layout">
      <div className="desktop-main-outlet">
        <PageContent />
      </div>
    </Layout>
  );
};

export default DesktopLayout;
